// extracted by mini-css-extract-plugin
export default {"BasePanel":"BasePanelbu92DifwdlnH","BasePanel-root":"BasePanel-root3j8_ASvfPJYu"};